export default __webpack_public_path__ + "static/gorilla-336f8cba31bb865bbd460f9c35c7635d.png";